function errorContext(cb) {
    {
        cb();
    }
}

export { errorContext };
//# sourceMappingURL=errorContext.js.map
